import { Col, Modal, Row } from "antd";
import React from "react";

import "../../../../assets/style/modalStyle/addAccount.scss";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import { bannerSelector } from "../../../../services/selector/index.";
import { checkNumber } from "../../../../utils/functionCommon";
import {
  saveConfigBanner,
  setNumberDefault,
} from "../../../../services/slice/BannerSlice";
import TranslateText from "../../TranslateText";
import BaseButton from "../../Button/BaseButton";
import LabelInput from "../../LabelInput";
import InputText from "../../Input/InputText";

const ModalSetLimitBanner = ({ open, setOpen, setNumber, number }) => {
  const { t } = useTranslation();
  const bannerState = useSelector(bannerSelector);
  const { lengthConfig } = bannerState;
  const [data, setData] = useState(number);
  const dispatch = useDispatch();
  const handleCancel = () => {
    setOpen(false);
  };
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });

  const handleSave = () => {
    if (Number(data) < lengthConfig) {
      Modal.error({
        className: "wrapperModalErrConfigBanner",
        centered: true,
        width: 590,
        title: <span style={{ fontSize: 20, fontWeight: 700 }}>Lỗi</span>,

        content: (
          <>
            <p style={{ fontSize: 20 }}>
              Số lượng banner đang được hiển thị là{" "}
              <span style={{ color: "#047DE7" }}>{lengthConfig}</span>{" "}
            </p>
            <p style={{ fontSize: 20 }}>
              Bạn không thể thiết lập cấu hình số lượng banner hiển thị tối đa
              nhỏ hơn số lượng banner đang được hiển thị. Vui lòng chọn lại.
            </p>
          </>
        ),
      });

      return;
    }
    if (!checkNumber(data) || data < 0) {
      setError({
        isError: true,
        msg: "Số không đúng định dạng vui lòng nhập lại",
      });
      return;
    }
    setError({
      isError: false,
      msg: "",
    });
    setNumber(data);
    dispatch(setNumberDefault(data));
    dispatch(
      saveConfigBanner({
        name: "banner",
        number: data,
      })
    );
    setOpen(false);
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text={"Cấu hình hiển thị"} />}
        centered
        open={open}
        className="warrperModalAddAcc"
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              isEnter={true}
              width={155}
              content={"Lưu"}
              typeBtn="btnOrange"
              handleClick={handleSave}
            />
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Row
          align={"middle"}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSave();
            }
          }}
        >
          <Col
            span={16}
            style={{
              fontSize: "2rem",
              fontWeight: 500,
            }}
          >
            <LabelInput text={"Số lượng banner hiển thị tối đa"} />
          </Col>
          <Col span={8}>
            <InputText
              focus
              text={data}
              setText={(value) => setData(value)}
              typeInput={"baseInput"}
              placeholder={"Nhập số lượng"}
            />
          </Col>
        </Row>
        {error.isError ? <small className="msg">{t(error.msg)}</small> : null}
      </Modal>
    </>
  );
};

export default ModalSetLimitBanner;
